import React, { useEffect, useState } from "react";
import styleSheet from "./style.module.scss";

import SyIcon from "../sy-icon";
import OrbInput from "../../forms/orb-input";
import dayjs from "dayjs";
import OrbPopover from "../orb-popover";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getAuthDetails } from "../../../feature/auth-slice";
import { timeLineProps } from "./interface";

type Props = {};

const OrbTimeLine = (props: timeLineProps) => {
  const { color, onClickSend, timeLineData, editTimeLine } = props;
  const [showInput, setShowInput] = useState<any>(false);
  const [modifyedData, setModifyedData] = useState<any>([]);
  const timeLineStyle = color ? { backgroundColor: color } : {};
  const [isEdit, setIsEdit] = useState<any>({});
  const authSlice = useSelector(getAuthDetails);
  // New states for popover
  const [popoverAnchor, setPopoverAnchor] = useState<null | HTMLElement>(null);
  const [activeId, setActiveId] = useState<string | null>(null);
  const { t } = useTranslation();
  const onChangeVal = (e: any) => {
    onClickSend(e);
    setShowInput(false);
  };

  const onChangeEdit = (data: any) => {
    data.otl_timeline = {
      tl_name: null,
      tl_action: data.otl_timeline,
      tl_fields: null,
      tl_doc: null,
    };
    onClickSend(data, "edit");
    setIsEdit({});
  };
  const onClickIcon = () => {
    setShowInput(true);
  };

  const modifyTimeLineData = (data: any) => {
    if (data[0]?.otl_id && editTimeLine) {
      data.unshift({});
      return data;
    } else {
      return data;
    }
  };
  const getTime = (time: any, format: any) => {
    return dayjs(time).format(format);
  };

  const handleOpenPopOver = (e: React.MouseEvent<HTMLElement>, id: string) => {
    setPopoverAnchor(e?.currentTarget);
    setActiveId(id);
  };

  const handleClosePopover = () => {
    setPopoverAnchor(null);
    setActiveId(null);
  };

  const onClickPopoverIcons = (data: any, type: any) => {
    if (type === "flag") {
      onClickSend(data, type);
    } else if (type === "edit") {
      setIsEdit(data);
    } else if (type === "delete") {
      onClickSend(data, "delete");
    }

    setActiveId(null);
  };

  useEffect(() => {
    let data =timeLineData

    data = data.filter((val: any) => {

      if (!editTimeLine){
        if(val.otl_timeline.tl_fields){
          return false
        }else if(val.otl_timeline.tl_doc){
          return false
        }else{
          return true
        }

      }else{
        return true
      }

    });
    setModifyedData(modifyTimeLineData(data));
  }, [timeLineData]);

  const EditDeleteContent = ({ data }: any) => {
    return (
      <>
        <div className="d-flex">
          <SyIcon
            name={`${data.flag ? "turned_in" : "turned_in_not"}`}
            iconColor="rgba(255, 255, 255, 0.3)"
            size="sm"
            className={"pointer"}
            onClick={() => onClickPopoverIcons(data, "flag")}
          />
          <SyIcon
            name={"edit"}
            iconColor="rgba(255, 255, 255, 0.3)"
            size="sm"
            className={"pointer"}
            onClick={() => onClickPopoverIcons(data, "edit")}
          />
          <SyIcon
            name={"delete"}
            iconColor="rgba(255, 255, 255, 0.3)"
            size="sm"
            className={"pointer"}
            onClick={() => onClickPopoverIcons(data, "delete")}
          />
        </div>
      </>
    );
  };

  return (
    <div className={`${styleSheet.container}`}>
      <div className={`${styleSheet.main_timeline} mt-5`}>
        {modifyedData?.map((data: any, index: any) => (
   
          <div
            key={data.otl_id || index}
            className={`${styleSheet.timeline} ${
              index % 2 === 0 ? styleSheet.right : styleSheet.left
            } d-flex `}
          >
            {data.created_at && (
              <>
                <span
                  className={`${
                    index % 2 === 0
                      ? styleSheet.datelineLabel_right
                      : styleSheet.datelineLabel_left
                  } bebas-neue`}
                >
                  {getTime(data.created_at, "DD.MM.YYYY")}
                </span>
                <span
                  className={`${
                    index % 2 === 0
                      ? styleSheet.timelineLabel_right
                      : styleSheet.timelineLabel_left
                  } bebas-neue`}
                >
                  {getTime(data.created_at, "HH:mm")}
                  <span className="mohave"> Uhr</span>
                </span>
              </>
            )}

            {data.otl_id ? (
              <>
                <span
                  className={`${
                    index % 2 === 0 ? styleSheet.dot_right : styleSheet.dot_left
                  } ${data.flag ? "bg-success" : ""}`}
                ></span>
                {data.edit && editTimeLine ? (
                  <span id={data.otl_id}>
                    <span
                      onClick={(e) => handleOpenPopOver(e, data.otl_id)}
                      className="inline-flex"
                    >
                      <SyIcon
                        name={"more_vert"}
                        iconColor="rgba(255, 255, 255, 0.3)"
                        size="sm"
                        className={"pointer"}
                      />
                    </span>

                    <OrbPopover
                      open={activeId === data.otl_id}
                      anchorTarget={popoverAnchor}
                      id={data.otl_id}
                      onClose={handleClosePopover}
                    >
                      <EditDeleteContent data={data} />
                    </OrbPopover>
                  </span>
                ) : null}
              </>
            ) : !showInput ? (
              <div className="mb-2">
                <SyIcon
                  name={"add_circle_outline"}
                  iconColor="rgba(255, 255, 255, 0.3)"
                  size="sm"
                  className={"pointer  ps-2 ms-2"}
                  onClick={onClickIcon}
                />
              </div>
            ) : (
              <div className="mb-4 ps-2 ms-2 w-100">
                <OrbInput
                  type={"text"}
                  withIcon={true}
                  inputType="outlined"
                  iconStyle="outlined"
                  iconName={"save"}
                  iconType="symbols"
                  id={"timeline"}
                  showError={false}
                  onClick={onChangeVal}
                  iconTip="send"
                />
              </div>
            )}
            <div className={`${index % 2 === 0 ? "ms-2" : "me-2"} `}>
              {isEdit.otl_id && isEdit.otl_id == data.otl_id ? (
                <div>
                  <OrbInput
                    type={"text"}
                    withIcon={true}
                    inputType="outlined"
                    iconStyle="outlined"
                    iconName={"save"}
                    iconType="symbols"
                    id={"timeline"}
                    showError={false}
                    value={isEdit.otl_timeline.tl_action}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      setIsEdit({ ...isEdit, otl_timeline: e.target.value })
                    }
                    onClick={() => onChangeEdit(isEdit)}
                    iconTip="send"
                  />
                </div>
              ) : data.otl_timeline ? (
                <p className="text-white mohave font-15   ">
                  {" "}
                  <p className="mb-0">
                  {data.otl_timeline?.tl_name? <span> {data.otl_timeline?.tl_name}</span>:null}
                  <span> {t(data.otl_timeline?.tl_action)}</span>
                  
                  </p>
                  {data.otl_timeline?.tl_fields ? (
                    <span className="opacity-50 font-10">
                      {`( ${t("fields")} : ${data.otl_timeline?.tl_fields})`}{" "}
                    </span>
                  ) : null}
                  {data.otl_timeline?.tl_doc ? (
                    <span className="opacity-50 font-10">
                      {`(${data.otl_timeline?.tl_doc})`}{" "}
                    </span>
                  ) : null}
                </p>
              ) : null}
            </div>
          </div>
     
        ))}
      </div>
    </div>
  );
};

export default OrbTimeLine;
